module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0021.jpg?v=86850ace";